import React from 'react';
import { MingoBirdIcon, resolveTierIndex, MINGO_BIRD_TIERS } from '../assets/mingo-bird';
import { useMingo } from '../context/MingoContext';

const SIZE_MAP = {
  sm: 18,
  md: 22,
  lg: 28,
};

/**
 * @param {object} p
 * @param {number} p.score
 * @param {'sm'|'md'|'lg'} [p.size]
 * @param {boolean} [p.simple]
 * @param {boolean} [p.isNew] 실제 평가 신호(노쇼/신고/리뷰)가 0건일 때 true.
 *   신호 없이 만점(100)으로 뜨는 것과 실제로 검증된 만점을 구분하기 위해
 *   신규 유저는 점수와 무관하게 항상 '밍고알'(최하위) 등급으로 표시한다.
 * @param {string} [p.title] 커스텀 title(hover) 텍스트. 없으면 기본 한국어 문구 사용.
 * @param {string} [p.ariaLabel] 커스텀 접근성 라벨. 없으면 기본 한국어 문구 사용.
 */
function ActivityScoreBadge({ score, size = 'md', simple = false, isNew = false, title, ariaLabel }) {
  const { t } = useMingo();
  const birdSize = SIZE_MAP[size] || SIZE_MAP.md;
  const safeScore = Number.isFinite(score) ? score : 0;
  const tierIndex = isNew ? MINGO_BIRD_TIERS.length - 1 : resolveTierIndex(score);
  const defaultText = isNew ? t('myPage.mannerNewDesc') : `${t('myPage.manner')} ${safeScore.toFixed(1)}%`;
  const resolvedTitle = title || defaultText;
  const resolvedAriaLabel = ariaLabel || defaultText;

  if (simple) {
    return (
      <span
        className="mingo-activity-badge mingo-activity-badge--simple"
        aria-hidden="true"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          verticalAlign: 'middle',
          lineHeight: 1,
          opacity: 0.9,
        }}
      >
        <MingoBirdIcon tierIndex={tierIndex} size={Math.max(14, birdSize - 2)} />
      </span>
    );
  }

  return (
    <span
      title={resolvedTitle}
      aria-label={resolvedAriaLabel}
      className="mingo-activity-badge"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        lineHeight: 1,
      }}
    >
      <MingoBirdIcon tierIndex={tierIndex} size={birdSize} />
    </span>
  );
}

export default ActivityScoreBadge;
